import axios from 'axios'
import React from 'react'
import { baseUrl } from '../assets/Animations'
import './teacher-availability.css'

const TeacherAvailability = () => {
    const [teachers, setTeachers] = React.useState([])
    const [students, setStudents] = React.useState([])
    const [masterObject, setMasterObject] = React.useState([])
    const [openTabs, setOpenTabs] = React.useState([])
    const listOfSchool = ['mma', 'lsma', 'tma', 'mor', 'psma']

    let myToken = localStorage.getItem('token')
    let myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        axios.get(`${baseUrl}/initialadminrequest`, myHeader)
        .then((res) => setTeachers(res.data))
        .catch((err) => console.log(err))
        axios.get(`${baseUrl}/school-management`, myHeader)
        .then((res) => setStudents(res.data))
        .catch((err) => console.log(err))
    }, [])

    React.useEffect(() => {
        if(teachers.length > 0 && students.length > 0) {
            processTheTeachers()
        }
    }, [teachers, students])

    React.useEffect(() => {
        for(let i = 0; i < openTabs.length; i++) {
            document.getElementById(openTabs[i]).style.maxHeight = '1000px'
        }
    }, [openTabs])

    const processStudents = (obj) => {
        let myMasterObject = obj
        let schoolsTotals = {}
        for (let i = 0; i < students.length; i++) {
            const family = students[i];
            for (let i = 0; i < family.students.length; i++) {
                const stu = family.students[i];
                for (let i = 0; i < stu.instrumentList.length; i++) {
                    const inst = stu.instrumentList[i].parentInstrument === 'Skill' ? stu.instrumentList[i].name : stu.instrumentList[i].parentInstrument;
                    let lowerCaseSchool = family.school.toLocaleLowerCase()
                    if(myMasterObject[lowerCaseSchool]) {
                        if(myMasterObject[lowerCaseSchool][inst]) {
                            myMasterObject[lowerCaseSchool][inst]['total'] = myMasterObject[lowerCaseSchool][inst]['total'] + 1
                        } else {
                            myMasterObject[lowerCaseSchool][inst] = {'needTeacher': true, 'percentage': 0, 'total': 0}
                        }
                    }
                }
            }
        }
        Object.keys(myMasterObject).map((schools) => {
            schoolsTotals[schools] = 0
            Object.keys(myMasterObject[schools]).map((inst) => {
                schoolsTotals[schools] = myMasterObject[schools][inst]['total'] + schoolsTotals[schools]
            })
        })
        let myArray = []
        Object.keys(myMasterObject).map((schools) => {
            Object.keys(myMasterObject[schools]).map((inst) => {
                myMasterObject[schools][inst]['school'] = schools
                myMasterObject[schools][inst]['instrument'] = inst
                myMasterObject[schools][inst]['percentage'] = myMasterObject[schools][inst]['total'] / schoolsTotals[schools]
                myMasterObject[schools][inst]['percentage'] = Math.round(myMasterObject[schools][inst]['percentage'] * 100) / 100
                myMasterObject[schools][inst]['percentage'] = myMasterObject[schools][inst]['percentage'] * 100
                myArray.push(myMasterObject[schools][inst])
                myArray.sort((a,b) => (b['percentage'] - a['percentage']))
            })

        })
        setMasterObject(myArray)
    }

    const processTheTeachers = () => {
        let myObject = {}
        for(let i = 0; i < teachers.length; i++) {
            myObject[teachers[i].School] = {}
        }
        for(let i = 0; i < teachers.length; i++) {
            if(teachers[i].WantsMoreStudents && teachers[i].Status === 'Active') {
                let t = teachers[i]
                for(let i = 0; i < t.InstrumentList.length; i++) {
                    let fixedInstrumentName = t.InstrumentList[i].parentInstrument === 'Skill' ? t.InstrumentList[i].name : t.InstrumentList[i].parentInstrument
                    if(myObject[t.School][fixedInstrumentName]) {
                        //if(myObject[t.School][t.InstrumentList[i].parentInstrument].some(e => e.Name === t.Name)) {
                        //    // INSURE NO DUPLICATES
                        //} else {
                            Object.keys(t.AvailabilityDetails).map((day) => {
                                if(myObject[t.School][fixedInstrumentName]['availableDays'][day]) {
                                    if(t.AvailabilityDetails[day].length > 0) {
                                        if(myObject[t.School][fixedInstrumentName]['availableDays'][day].some(e => e.Name === t.Name)) {
                                           // INSURE NO DUPLICATES
                                        } else {
                                            myObject[t.School][fixedInstrumentName]['availableDays'][day].push({Name: t.Name, Image: t.ImageName, AvailabilityDetails: t.AvailabilityDetails[day]})
                                        }
                                    }
                                } else {
                                    if(t.AvailabilityDetails[day].length > 0) {
                                        myObject[t.School][fixedInstrumentName]['availableDays'][day] = [{Name: t.Name, Image: t.ImageName, AvailabilityDetails: t.AvailabilityDetails[day]}]
                                    } else {
                                        myObject[t.School][fixedInstrumentName]['availableDays'][day] = []
                                    }
                                }
                            })
                        //}
                    } else {
                        myObject[t.School][fixedInstrumentName] = {'needTeacher': false, 'percentage': 0, 'total': 0, 'availableDays': {}}
                        Object.keys(t.AvailabilityDetails).map((day) => {
                            if(myObject[t.School][fixedInstrumentName]['availableDays'][day]) {
                                if(t.AvailabilityDetails[day].length > 0) {
                                    if(myObject[t.School][fixedInstrumentName]['availableDays'][day].some(e => e.Name === t.Name)) {
                                       // INSURE NO DUPLICATES
                                    } else {
                                        myObject[t.School][fixedInstrumentName]['availableDays'][day].push({Name: t.Name, Image: t.ImageName, AvailabilityDetails: t.AvailabilityDetails[day]})
                                    }
                                }
                            } else {
                                if(t.AvailabilityDetails[day].length > 0) {
                                    myObject[t.School][fixedInstrumentName]['availableDays'][day] = [{Name: t.Name, TeacherID: t.TeacherID, Image: t.ImageName, AvailabilityDetails: t.AvailabilityDetails[day]}]
                                } else {
                                    myObject[t.School][fixedInstrumentName]['availableDays'][day] = []
                                }
                            }
                        })
                    }
                }
            }
        }
        processStudents(myObject)
    }

    const changeTheTab = (id, size) => {
        if(openTabs.includes(id)) {
            document.getElementById(id).style.maxHeight = size
            setOpenTabs((prev) => (prev.filter((listId) => listId !== id)))
        } else {
            setOpenTabs((prev) => [...prev, id])
        }
    }

    const calculateColor = (inst) => {
        if(inst.needTeacher && inst.percentage > 2) {
            return {color: 'rgb(220, 0, 0)', animationIterationCount: 'infinite'}
        } else if (inst.needTeacher && inst.percentage < 3) {
            return {color: 'rgb(220, 0, 0)'}
        }
        let myObj = {}
        Object.keys(inst.availableDays).map((day) => {
            for(let i = 0; i < inst.availableDays[day].length; i++) {
                myObj[inst.availableDays[day][i].Name] = inst.availableDays[day][i].TeacherID
            }
        })
        let numberOfTeachersStudents = 0
        Object.keys(myObj).map((teach) => {
            for(let i = 0; i < students.length; i++) {
                if(students[i].familyStatus === 'Active') {
                    for(let j = 0; j < students[i].students.length; j++) {
                        if(students[i].students[j].studentStatus === 'Active') {
                            let teachersId = students[i].students[j].teachersId
                            if(myObj[teach] === teachersId) {
                               numberOfTeachersStudents = numberOfTeachersStudents + 1
                            }
                        }
                    }
                } 
             }
        })


        if(Object.keys(myObj).length === 1 && numberOfTeachersStudents < 2) {
            return {color: 'rgb(255, 200, 98)'}
        } else if (Object.keys(myObj).length === 1 && numberOfTeachersStudents < 5 && numberOfTeachersStudents > 1) {
            return {color: 'orange'}
        } else if (Object.keys(myObj).length === 1 && numberOfTeachersStudents > 4) {
            return {color: 'orangered'}
        }
    }

    if(masterObject.length > 0) {
        return(
            <div className='teacher-avail__wrapper'>
                {listOfSchool.map((school) => (
                    <div key={school} className='teacher-avail__school-column'>
                        <div>{school.toUpperCase()}</div>
                        {masterObject.map((inst) => (
                            inst.school === school && inst.percentage > 1 &&
                            <div key={`${school}-${inst.instrument}`} className='teacher-avail__instrument' id={`${school}-${inst.instrument}`}>
                                <h4 style={calculateColor(inst)} onClick={() => changeTheTab(`${school}-${inst.instrument}`, '30px')} className='teacher-avail__instrument__name'>{inst.instrument} <div className='teacher-avail__instrument__name__percentage'>{inst.percentage}%</div></h4>
                                {inst.availableDays &&
                                    <div>
                                        {Object.keys(inst.availableDays).map((day) => (
                                            inst.availableDays[day].length > 0 &&
                                            <div key={`${school}-${inst.instrument}-${day}`} className='teacher-avail__instrument__day__wrapper' id={`${school}-${inst.instrument}-${day}`}>
                                                <div onClick={() => changeTheTab(`${school}-${inst.instrument}-${day}`, '22px')} style={inst.availableDays[day].length > 1 ? {color: 'green'} : {color: 'orange'}} className='teacher-avail__instrument__day'>{day}</div>
                                                {inst.availableDays[day].map((teacher) => (
                                                    <div key={teacher.Name} className='teacher-avail__day__teacher-wrapper'>
                                                        <img className='teacher-avail__day__teacher__img' src={`https://app.atharo.app/images/${teacher.Image}`} />
                                                        <h6 className='teacher-avail__day__teacher__name'>{teacher.Name.split(' ')[0]}</h6>
                                                        {teacher.AvailabilityDetails.map((times, i) => (
                                                            <div className='teacher-avail__day__teacher__time-slot' key={i}>{times.start}-{times.end}</div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                ))}
                <div className='teacher-avail__key'>
                    <div className='teacher-avail__text' style={{color: 'rgb(255, 200, 98)'}}>1 Teacher less than 2 students</div>
                    <div className='teacher-avail__text' style={{color: 'orange'}}>1 Teacher with between 2-5 students</div>
                    <div className='teacher-avail__text' style={{color: 'orangered'}}>1 Teacher with 5+ students</div>
                    <div className='teacher-avail__text' style={{color: 'rgb(220, 0, 0)'}}>No Teacher Available</div>
                </div>
            </div>
        )
    } else {
        return(
            <div className='teacher-avail__wrapper'>
                <div className='teacher-avail__loading-screen'>Calculating Availabilities...</div>
            </div>
        )
    }
}
export default TeacherAvailability